import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import HistoryIcon from '@mui/icons-material/History';
import { useNavigate } from 'react-router-dom';
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import LogoutIcon from '@mui/icons-material/Logout';
import LearnIcon from '@mui/icons-material/School';
import MobileFriendly from '@mui/icons-material/MobileFriendly';
import IconHome from '@mui/icons-material/Home';
import IconPDF from '@mui/icons-material/PictureAsPdf';
import BusAlert from '@mui/icons-material/BusAlert';
import Directions from '@mui/icons-material/Directions';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ConstructionIcon from '@mui/icons-material/Construction';
import LocalParking from '@mui/icons-material/LocalParking';
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";


export default function TemporaryDrawer({ open, toggleDrawer }) {
  const navigate = useNavigate();
  const handleNavigate = (path) => () => {
    navigate(path);
    toggleDrawer(false)();
  };
  const handleSignOut = () => {
    signOut(auth)
      .then(() => console.log("Sign Out"))
      .catch((error) => console.log(error));
  };

  const [openSubMenu, setOpenSubMenu] = React.useState(false);
  const [openHandysCollections, setOpenHandysCollections] = React.useState(false);
  const [handysCollections, setHandysCollections] = React.useState([]);
  const [isLoadingHandysCollections, setIsLoadingHandysCollections] = React.useState(false);
  const handleSubMenuClick = () => {
    setOpenSubMenu((prev) => !prev);
    toggleDrawer(true)();
  };

  const handleHandysCollectionsClick = () => {
    setOpenHandysCollections((prev) => !prev);
    toggleDrawer(true)();
  };

  React.useEffect(() => {
    const loadHandysCollections = async () => {
      setIsLoadingHandysCollections(true);
      try {
        const collectionsRef = collection(db, "handys_schule_collections");
        const snapshot = await getDocs(query(collectionsRef, orderBy("order", "asc")));
        const list = snapshot.docs.map((docSnap) => ({
          id: docSnap.id,
          ...docSnap.data()
        }));
        setHandysCollections(list);
      } catch (error) {
        console.error("Failed to load handys schule collections:", error);
      } finally {
        setIsLoadingHandysCollections(false);
      }
    };

    void loadHandysCollections();
  }, []);

  const DrawerList = (
    <Box sx={{
      width: 250,
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    }} role="presentation">
      <Box sx={{ flexGrow: 1 }}>
        <Divider />
        <List>
          {/* <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate("/home")}>
              <ListItemIcon>
                <IconHome />
              </ListItemIcon>
              <ListItemText primary="Home" />
            </ListItemButton>
          </ListItem> */}
          <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate("/home")}>
              <ListItemIcon>
                <IconPDF />
              </ListItemIcon>
              <ListItemText primary="Fahrpläne" />
            </ListItemButton>
          </ListItem>
          {/* <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate("/plans_choice")}>
              <ListItemIcon>
                <IconPDF />
              </ListItemIcon>
              <ListItemText primary="Plan suchen" />
            </ListItemButton>
          </ListItem> */}

          <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate("/umleitungen")}>
              <ListItemIcon>
                <Directions />
              </ListItemIcon>
              <ListItemText primary="Umleitungen" />
            </ListItemButton>
          </ListItem>


          <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate("/betrinfos")}>
              <ListItemIcon>
                <BusAlert />
              </ListItemIcon>
              <ListItemText primary="Betrieb. Infos" />
            </ListItemButton>
          </ListItem>



          {/* Collapsible Submenu Example */}
          {/* <ListItem disablePadding>
            <ListItemButton onClick={handleSubMenuClick}>
              <ListItemIcon>
                <LearnIcon />
              </ListItemIcon>
              <ListItemText primary="Handys Schule" />
              {openSubMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </ListItem>
          <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/schul_meine_db")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="Meine-DB" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/bvh_app")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="BVH App" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/eco_app")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="EcoApp" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/lap_id")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="LapId" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/evi_app")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="Evi" />
              </ListItemButton>

              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/teams_app")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="Teams" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/outlook_app")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="OutLook" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/stops_indicator")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="Stops Indicator" />
              </ListItemButton>
              <ListItemButton sx={{ pl: 4 }} onClick={handleNavigate("/ubk_app")}>
                <ListItemIcon>
                  <MobileFriendly />
                </ListItemIcon>
                <ListItemText primary="UBK Kleidung" />
              </ListItemButton>
            </List>
          </Collapse> */}


          {/* Handys Schule */}
          <ListItem disablePadding>
            <ListItemButton onClick={handleHandysCollectionsClick}>
              <ListItemIcon>
                <LearnIcon />
              </ListItemIcon>
              <ListItemText primary="Handys Schule" />
              {openHandysCollections ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </ListItem>
          <Collapse in={openHandysCollections} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {isLoadingHandysCollections && (
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Lade..." />
                  </ListItemButton>
                </ListItem>
              )}
              {!isLoadingHandysCollections && handysCollections.length === 0 && (
                <ListItem disablePadding>
                  <ListItemButton>
                    <ListItemText primary="Keine Sammlungen" />
                  </ListItemButton>
                </ListItem>
              )}
              {handysCollections.map((col) => (
                <ListItemButton
                  key={col.id}
                  sx={{ pl: 4 }}
                  onClick={handleNavigate(`/handys_school/${col.id}`)}
                >
                  <ListItemIcon>
                    <MobileFriendly />
                  </ListItemIcon>
                  <ListItemText primary={col.name || "Sammlung"} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>

          <ListItem button onClick={handleNavigate('/chronicles')}>
            <ListItemIcon>
              <HistoryIcon />
            </ListItemIcon>
            <ListItemText
              primary="Firmengeschichte"
            />

          </ListItem>

          <ListItem button onClick={handleNavigate('/user_manuals')}>
            <ListItemIcon>
              <ConstructionIcon />
            </ListItemIcon>
            <ListItemText
              primary="Handbuch"
            />
          </ListItem>

          <ListItem button onClick={handleNavigate('/bus_park_print')}>
            <ListItemIcon>
              <LocalParking />
            </ListItemIcon>
            <ListItemText
              primary="Bus Park"
            />
          </ListItem>

          <Divider />

          <ListItemButton onClick={handleSignOut}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
          <Divider />
        </List>

      </Box>

      {/* Bottom section - will stick to bottom */}
      <Box>
        <List>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate("/adm/qr")}>
              <ListItemIcon>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Admin Panel" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate("/adm/bus_park")}>
              <ListItemIcon>
                <AdminPanelSettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Hofdienst Panel" />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Box>
  );

  return (
    <div>
      {/* <Button onClick={toggleDrawer(true)}>Open drawer</Button> */}
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
